import { combineReducers } from 'redux';

import fetchCityToCityInterlinksReducerMap, {
    fetchCityToCityInterlinksAction,
} from './actions/fetchCityToCityInterlinks';
import fetchHomepageInterlinksReducerMap, {
    fetchHomepageInterlinksAction,
} from './actions/fetchHomepageInterlinks';
import appStateReducerMap, {
    selectors as interlinkDataSelectors,
} from './appstate';
import namespace from './types';

const reducer = combineReducers({
    ...fetchCityToCityInterlinksReducerMap,
    ...fetchHomepageInterlinksReducerMap,

    ...appStateReducerMap,
});

export {
    fetchCityToCityInterlinksAction,
    fetchHomepageInterlinksAction,

    interlinkDataSelectors,
};

export default {
    [namespace]: reducer,
};
